var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPricedropLogo = function SvgPricedropLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pricedrop-logo_svg__a)",
    d: "M.374 9.25 2.693 1.32a1 1 0 0 1 .96-.72h4.843a1 1 0 0 1 .906 1.423L7.312 6.51h2.479c.86 0 1.319 1.014.751 1.66L3.64 16.032c-.335.381-.96.077-.867-.422l.948-5.078H1.334a1 1 0 0 1-.96-1.281"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pricedrop-logo_svg__a",
    x1: 6,
    x2: 6,
    y1: 0,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC0C1C",
    stopOpacity: 0.2
  })))));
};
export default SvgPricedropLogo;